import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  main: {
    [theme.breakpoints.down('sm')]: {
      background: theme.palette.common.white,
      paddingBottom: 58,
      width: '100%',
      padding: 0,
      margin: 0,
    },
  },
  cancelMain: {
    maxWidth: '100%',
    margin: 0,
    width: '100%',
    padding: '32px 40px',
    [theme.breakpoints.down('xs')]: {
      padding: '56px 16px',
      background: '#f5f6fa',
    },
  },
  cancelledMain: {
    maxWidth: '100%',
    margin: 0,
    width: '100%',
    padding: '32px 40px',
    [theme.breakpoints.down('xs')]: {
      padding: '0',
      background: '#f5f6fa',
    },
  },
  iconTask: {
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'block',
  },
}))
